import React from "react";
import { Grid, Button, useTheme, useMediaQuery } from "@mui/material";
import { events } from "../../../../../data/Data";
import { Link } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { SnackbarCloseReason } from "@mui/material/Snackbar";
import EventCardComponent from "../../../../../components/core-components/eventsCard";
import SnackbarComponent from "../../../../../components/core-components/snackbar";
import TitleSectionComponent from "../../../../../components/core-components/titleSection";
import { useQuery } from "@tanstack/react-query";
import { PostsService } from "../../../../../network/PostsService";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

const StyledSwiper = styled(Swiper)(({ theme }) => ({
  '& .swiper-button-next, & .swiper-button-prev': {
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    width: '45px',
    height: '45px',
    borderRadius: '50%',
    boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
  
    transition: 'all 0.3s ease',
    '&:after': {
      fontSize: '20px',
      color: 'var(--red-primary)',
      fontWeight: 'bold'
    },
    '&:hover': {
      backgroundColor: '#fff',
      boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
      transform: 'scale(1.1)'
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  '& .swiper-slide': {
    width: '100%',
    height: 'auto',
    transition: 'transform 0.3s ease',
    [theme.breakpoints.down('sm')]: {
      padding: '10px'
    }
  }
}));

function EventsSection() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = React.useState(false);

  const postsService = new PostsService();

  const { data } = useQuery({
    queryKey: ["posts"],
    queryFn: async () => {
      const res = await postsService.getAll({
        limit: 6
      });
      return res?.data;
    }
  });

  const sortedData = data?.sort(
    (a: any, b: any) => new Date(b.date).getTime() - new Date(a.date).getTime()
  );

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  return (
    <Grid
      container
      spacing={isMobile ? 1 : 4}
      sx={{
        width: '100%',
        margin: isMobile ? '0 auto' : '-170px 0 -50px 0',
        padding: isMobile ? '10px' : '40px',
        marginTop: isMobile ? '-70px ' : '-170px',
      }}
    >
      <Grid item xs={12}>
        <TitleSectionComponent titleText='' />
      </Grid>
      
      <Grid item xs={12}>
        <Box sx={{
          width: isMobile ? '120%' : '100%', 
          maxWidth: '1400px', 
          marginLeft: isMobile ? '-120px' : '20px', 
          margin: isMobile ?'-20px 20px 0 -40px' :"0 auto", 
          padding: isMobile ? '0' : '20px', 
          overflow: 'hidden',
          [theme.breakpoints.down('sm')]: {
            maxWidth: '100vw',
            padding: '10px'
          },
          [theme.breakpoints.up('xl')]: {
            maxWidth: '1400px'
          }
        }}>
          <StyledSwiper
            modules={[Autoplay, Navigation]}
            spaceBetween={isMobile ? 0 : 20}
            slidesPerView={1}
            navigation={!isMobile}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true
            }}
            loop={true}
            style={{
              margin: '0 auto', 
              width: '100%'
            }}
          >
            {sortedData?.map((event: any, index: number) => (
              <SwiperSlide key={index}>
                <Box sx={{
                  transform: 'scale(1)', 
                  transition: 'all 0.3s ease',
                  margin: isMobile ? '0' : '10px', 
                  height: isMobile ? 'auto' : 'auto', 
                  '& img': {
                    width: '100%',
                    height: isMobile ? '300px' : '500px', 
                    objectFit: 'cover',
                    [theme.breakpoints.up('lg')]: {
                      height: '600px' 
                    },
                    [theme.breakpoints.up('xl')]: {
                      height: '680px' 
                    }
                  }
                }}>
                  <EventCardComponent event={event} handleClick={handleClick} />
                </Box>
              </SwiperSlide>
            ))}
          </StyledSwiper>
        </Box>
      </Grid>

      <Grid item xs={12} sx={{ 
        display: 'flex', 
        justifyContent: 'center',
        padding: isMobile ? '0' : '0'
      }}>
        <Link to="/etkinlikler" style={{ width: isMobile ? '100%' : 'auto' }}>
          <Button
            variant='contained'
            endIcon={<ArrowForwardIcon />}
            sx={{
              mt: isMobile ? 1 : "-30px",
              width: isMobile ? '100%' : 'auto',
              minWidth: '200px',
              backgroundColor: "var(--black-primary)",
              color: "var(--white-color)",
              borderRadius: "20px",
              padding: isMobile ? "8px 16px" : "5px 20px",
              height: isMobile ? "45px" : "50px",
              textTransform: "capitalize",
              "&:hover": { backgroundColor: "var(--black-color)" }
            }}
          >
            <span className='B-18' style={{ color: "var(--white-color)" }}>
              Tümünü Gör
            </span>
          </Button>
        </Link>
      </Grid>

      <SnackbarComponent
        open={open}
        handleClose={handleClose}
        alertText='Etkinlik linki başarıyla kopyalandı!'
      />
    </Grid>
  );
}

export default EventsSection;